import { LinearProgress } from "@/components/progress";
import { DollarData } from "../schema/price-board.schema";
import { DollarPriceCard } from "./dollar/DollarPriceCard";
import { NoData } from "@/components/common/section-components/NoData";
import { Box } from "@chakra-ui/react";

interface Props {
  loadingPrices: boolean;
  sectionData?: DollarData;
}

export const DollarTable = ({ loadingPrices, sectionData }: Props) => {
  return loadingPrices ? (
    <LinearProgress />
  ) : (
    <>
      {!loadingPrices && Boolean(!sectionData?.dolarDivisa?.length) && (
        <Box marginTop="30px">
          <NoData />
        </Box>
      )}
      {!loadingPrices && Boolean(sectionData?.dolarDivisa?.length) && (
        <DollarPriceCard sectionData={sectionData} />
      )}
    </>
  );
};
